export default __webpack_public_path__ + "static/media/ic_egypt.46fe742c.svg";